module.exports = __webpack_public_path__ + "img/14.51ae09a.jpg";